import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    root: '',
  },
  styles: {
    root: {},
  },
}));
